import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect } from 'react';
import Unity, { UnityContent } from 'react-unity-webgl';
import { connect } from 'react-redux';
import { handshake, EvalCode } from './UnityAPI';
import { setUnityContent } from '../redux/actions';
import './UnityWorld.css';

var UnityWorld = function UnityWorld(props) {
  var unity = props.unity,
      code = props.code,
      setUnityContent = props.setUnityContent;
  useEffect(function () {
    var unity = generateUnityContent();
    unity.on('MessageFromUnity', function (r) {
      if (handshake !== null) {
        var response = JSON.parse(r);
        handshake.resolve(response);
      }
    });
    setUnityContent(unity);
  }, [setUnityContent]);

  var generateUnityContent = function generateUnityContent() {
    var url = 'https://cs2n-unity-games.s3.amazonaws.com',
        build = 'dev-build001_04-03-1427';
    return new UnityContent("".concat(url, "/").concat(build, "/unity_game.json"), "".concat(url, "/").concat(build, "/UnityLoader.js"));
  };

  var runCode = function runCode(code) {
    EvalCode(code);
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: function () {
      var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", runCode(code));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onClick() {
        return _onClick.apply(this, arguments);
      }

      return onClick;
    }()
  }, "Run Code"), /*#__PURE__*/React.createElement("span", null, "Press Escape to restart the level"), unity.content ? /*#__PURE__*/React.createElement(Unity, {
    unityContent: unity.content,
    className: "unity_container"
  }) : unity.content);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    unity: state.unity
  };
};

var mapDisptachToProps = {
  setUnityContent: setUnityContent
};
export default connect(mapStateToProps, mapDisptachToProps)(UnityWorld);